import TableError from 'components/TableError';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Table } from 'reactstrap';
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import Loader from '../../../components/Loader';
import useRequest from '../../../hooks/useRequest';

const StaticPageMetadata = () => {
  const [pageModulesList, setPageModulesList] = useState([]);
  const [loading, setLoading] = useState(true);

  const [getPageCategoriesRequest] = useRequest({
    method: 'GET',
  });

  const [getPageSubModulesList] = useRequest({
    method: 'GET',
  });

  const [getPageModuleList] = useRequest({
    url: '/cms/admin/page/modules',
    method: 'GET',
  });

  const fetchData = async () => {
    try {
      const modules = await getPageModuleList();

      const allModulesData = await Promise.all(
        modules?.map(async (module) => {
          const subModules = await getPageSubModulesList({
            url: `/cms/admin/page/${module?.module}/sub-modules`,
          });

          const categories = await getPageCategoriesRequest({
            url: `/cms/admin/page/${module?.module}/categories`,
          });

          return {
            ...module,
            subModules,
            categories,
          };
        })
      );

      setPageModulesList(allModulesData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="page-content">
        <Loader isActive={loading} />
        <Container fluid>
          <Breadcrumbs title="Page" breadcrumbItem="Page Metadata List" />

          <Row className="mb-2 align-items-center">
            <Col sm="4">
              <div className="search-box me-2 mb-2 d-inline-block">
                <div className="position-relative font-bold">{pageModulesList?.length || 0} Page Metadata Found</div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg="12">
              <div className="">
                <div className="table-responsive" style={{ minHeight: 300 }}>
                  <Table className="project-list-table table-centered table-borderless">
                    <thead>
                      <tr className="table-warning">
                        <th scope="col" style={{ width: '60px' }}>
                          S.No.
                        </th>
                        <th scope="col">Module</th>
                        <th scope="col">Sub Modules</th>
                        <th scope="col">Categories</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(pageModulesList) ? (
                        pageModulesList.map((moduleElem, index) => (
                          <tr key={moduleElem?.module}>
                            <td>{index + 1}</td>
                            <td>{moduleElem?.module}</td>
                            <td>
                              {moduleElem?.subModules?.length > 0 ? (
                                moduleElem.subModules.map((elem, i) => (
                                  <div className="mb-1" key={i}>
                                    {i + 1}. {elem?.subModule}
                                  </div>
                                ))
                              ) : (
                                <div>No Submodules</div>
                              )}
                            </td>
                            <td>
                              {moduleElem?.categories?.length > 0 ? (
                                moduleElem.categories.map((elem, i) => (
                                  <div className="mb-1" key={i}>
                                    {i + 1}. {elem?.category}
                                  </div>
                                ))
                              ) : (
                                <div>No Categories</div>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <TableError />
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default StaticPageMetadata;
